var _style, _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMommiesIg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svgQrWrapper",
    viewBox: "0 0 300 300",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 300,
    height: 300,
    style: {
      width: "100%",
      height: "100%",
      backgroundColor: "rgb(255, 255, 255)"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(9, 9)scale(0.95)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".background-color{ fill: #fff; }.dot-color{ fill: #000000; }.corners-square-color-0-0{ fill: #000000; }.corners-dot-color-0-0{ fill: #000000; }.corners-square-color-1-0{ fill: #000000; }.corners-dot-color-1-0{ fill: #000000; }.corners-square-color-0-1{ fill: #000000; }.corners-dot-color-0-1{ fill: #000000; }")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "dot-color"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 85,
    width: 10,
    height: 10,
    transform: "rotate(0,10,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 95,
    width: 10,
    height: 10,
    transform: "rotate(0,10,100)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 135,
    width: 10,
    height: 10,
    transform: "rotate(0,10,140)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 165,
    width: 10,
    height: 10,
    transform: "rotate(0,10,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 175,
    width: 10,
    height: 10,
    transform: "rotate(0,10,180)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 185,
    width: 10,
    height: 10,
    transform: "rotate(0,10,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 85,
    width: 10,
    height: 10,
    transform: "rotate(0,20,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 95,
    width: 10,
    height: 10,
    transform: "rotate(0,20,100)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 115,
    width: 10,
    height: 10,
    transform: "rotate(0,20,120)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 125,
    width: 10,
    height: 10,
    transform: "rotate(0,20,130)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 135,
    width: 10,
    height: 10,
    transform: "rotate(0,20,140)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 165,
    width: 10,
    height: 10,
    transform: "rotate(0,20,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 175,
    width: 10,
    height: 10,
    transform: "rotate(0,20,180)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 185,
    width: 10,
    height: 10,
    transform: "rotate(0,20,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 85,
    width: 10,
    height: 10,
    transform: "rotate(0,30,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 105,
    width: 10,
    height: 10,
    transform: "rotate(0,30,110)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 145,
    width: 10,
    height: 10,
    transform: "rotate(0,30,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 195,
    width: 10,
    height: 10,
    transform: "rotate(0,30,200)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 85,
    width: 10,
    height: 10,
    transform: "rotate(0,40,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 105,
    width: 10,
    height: 10,
    transform: "rotate(0,40,110)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 135,
    width: 10,
    height: 10,
    transform: "rotate(0,40,140)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 155,
    width: 10,
    height: 10,
    transform: "rotate(0,40,160)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 165,
    width: 10,
    height: 10,
    transform: "rotate(0,40,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 185,
    width: 10,
    height: 10,
    transform: "rotate(0,40,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 85,
    width: 10,
    height: 10,
    transform: "rotate(0,50,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 195,
    width: 10,
    height: 10,
    transform: "rotate(0,50,200)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 205,
    width: 10,
    height: 10,
    transform: "rotate(0,50,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 95,
    width: 10,
    height: 10,
    transform: "rotate(0,60,100)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 115,
    width: 10,
    height: 10,
    transform: "rotate(0,60,120)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 135,
    width: 10,
    height: 10,
    transform: "rotate(0,60,140)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 145,
    width: 10,
    height: 10,
    transform: "rotate(0,60,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 155,
    width: 10,
    height: 10,
    transform: "rotate(0,60,160)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 165,
    width: 10,
    height: 10,
    transform: "rotate(0,60,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 175,
    width: 10,
    height: 10,
    transform: "rotate(0,60,180)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 195,
    width: 10,
    height: 10,
    transform: "rotate(0,60,200)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 205,
    width: 10,
    height: 10,
    transform: "rotate(0,60,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 85,
    width: 10,
    height: 10,
    transform: "rotate(0,70,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 105,
    width: 10,
    height: 10,
    transform: "rotate(0,70,110)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 125,
    width: 10,
    height: 10,
    transform: "rotate(0,70,130)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 145,
    width: 10,
    height: 10,
    transform: "rotate(0,70,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 165,
    width: 10,
    height: 10,
    transform: "rotate(0,70,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 185,
    width: 10,
    height: 10,
    transform: "rotate(0,70,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 205,
    width: 10,
    height: 10,
    transform: "rotate(0,70,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 85,
    width: 10,
    height: 10,
    transform: "rotate(0,80,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 95,
    width: 10,
    height: 10,
    transform: "rotate(0,80,100)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 105,
    width: 10,
    height: 10,
    transform: "rotate(0,80,110)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 125,
    width: 10,
    height: 10,
    transform: "rotate(0,80,130)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 135,
    width: 10,
    height: 10,
    transform: "rotate(0,80,140)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 145,
    width: 10,
    height: 10,
    transform: "rotate(0,80,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 165,
    width: 10,
    height: 10,
    transform: "rotate(0,80,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 175,
    width: 10,
    height: 10,
    transform: "rotate(0,80,180)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 185,
    width: 10,
    height: 10,
    transform: "rotate(0,80,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 195,
    width: 10,
    height: 10,
    transform: "rotate(0,80,200)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 205,
    width: 10,
    height: 10,
    transform: "rotate(0,80,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 15,
    width: 10,
    height: 10,
    transform: "rotate(0,90,20)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 25,
    width: 10,
    height: 10,
    transform: "rotate(0,90,30)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 45,
    width: 10,
    height: 10,
    transform: "rotate(0,90,50)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 65,
    width: 10,
    height: 10,
    transform: "rotate(0,90,70)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 75,
    width: 10,
    height: 10,
    transform: "rotate(0,90,80)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 105,
    width: 10,
    height: 10,
    transform: "rotate(0,90,110)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 125,
    width: 10,
    height: 10,
    transform: "rotate(0,90,130)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 165,
    width: 10,
    height: 10,
    transform: "rotate(0,90,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 185,
    width: 10,
    height: 10,
    transform: "rotate(0,90,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 205,
    width: 10,
    height: 10,
    transform: "rotate(0,90,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 225,
    width: 10,
    height: 10,
    transform: "rotate(0,90,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 245,
    width: 10,
    height: 10,
    transform: "rotate(0,90,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 255,
    width: 10,
    height: 10,
    transform: "rotate(0,90,260)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 265,
    width: 10,
    height: 10,
    transform: "rotate(0,90,270)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 275,
    width: 10,
    height: 10,
    transform: "rotate(0,90,280)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 285,
    width: 10,
    height: 10,
    transform: "rotate(0,90,290)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 5,
    width: 10,
    height: 10,
    transform: "rotate(0,100,10)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 35,
    width: 10,
    height: 10,
    transform: "rotate(0,100,40)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 45,
    width: 10,
    height: 10,
    transform: "rotate(0,100,50)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 75,
    width: 10,
    height: 10,
    transform: "rotate(0,100,80)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 85,
    width: 10,
    height: 10,
    transform: "rotate(0,100,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 105,
    width: 10,
    height: 10,
    transform: "rotate(0,100,110)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 135,
    width: 10,
    height: 10,
    transform: "rotate(0,100,140)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 145,
    width: 10,
    height: 10,
    transform: "rotate(0,100,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 175,
    width: 10,
    height: 10,
    transform: "rotate(0,100,180)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 185,
    width: 10,
    height: 10,
    transform: "rotate(0,100,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 195,
    width: 10,
    height: 10,
    transform: "rotate(0,100,200)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 225,
    width: 10,
    height: 10,
    transform: "rotate(0,100,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 235,
    width: 10,
    height: 10,
    transform: "rotate(0,100,240)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 265,
    width: 10,
    height: 10,
    transform: "rotate(0,100,270)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 285,
    width: 10,
    height: 10,
    transform: "rotate(0,100,290)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 15,
    width: 10,
    height: 10,
    transform: "rotate(0,110,20)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 25,
    width: 10,
    height: 10,
    transform: "rotate(0,110,30)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 45,
    width: 10,
    height: 10,
    transform: "rotate(0,110,50)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 55,
    width: 10,
    height: 10,
    transform: "rotate(0,110,60)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 65,
    width: 10,
    height: 10,
    transform: "rotate(0,110,70)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 75,
    width: 10,
    height: 10,
    transform: "rotate(0,110,80)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 125,
    width: 10,
    height: 10,
    transform: "rotate(0,110,130)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 135,
    width: 10,
    height: 10,
    transform: "rotate(0,110,140)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 185,
    width: 10,
    height: 10,
    transform: "rotate(0,110,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 205,
    width: 10,
    height: 10,
    transform: "rotate(0,110,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 235,
    width: 10,
    height: 10,
    transform: "rotate(0,110,240)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 245,
    width: 10,
    height: 10,
    transform: "rotate(0,110,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 255,
    width: 10,
    height: 10,
    transform: "rotate(0,110,260)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 275,
    width: 10,
    height: 10,
    transform: "rotate(0,110,280)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 285,
    width: 10,
    height: 10,
    transform: "rotate(0,110,290)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115,
    y: 25,
    width: 10,
    height: 10,
    transform: "rotate(0,120,30)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115,
    y: 35,
    width: 10,
    height: 10,
    transform: "rotate(0,120,40)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115,
    y: 55,
    width: 10,
    height: 10,
    transform: "rotate(0,120,60)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115,
    y: 75,
    width: 10,
    height: 10,
    transform: "rotate(0,120,80)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115,
    y: 95,
    width: 10,
    height: 10,
    transform: "rotate(0,120,100)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115,
    y: 105,
    width: 10,
    height: 10,
    transform: "rotate(0,120,110)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115,
    y: 125,
    width: 10,
    height: 10,
    transform: "rotate(0,120,130)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115,
    y: 155,
    width: 10,
    height: 10,
    transform: "rotate(0,120,160)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115,
    y: 165,
    width: 10,
    height: 10,
    transform: "rotate(0,120,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115,
    y: 175,
    width: 10,
    height: 10,
    transform: "rotate(0,120,180)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115,
    y: 185,
    width: 10,
    height: 10,
    transform: "rotate(0,120,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115,
    y: 215,
    width: 10,
    height: 10,
    transform: "rotate(0,120,220)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115,
    y: 225,
    width: 10,
    height: 10,
    transform: "rotate(0,120,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115,
    y: 235,
    width: 10,
    height: 10,
    transform: "rotate(0,120,240)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115,
    y: 275,
    width: 10,
    height: 10,
    transform: "rotate(0,120,280)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 15,
    width: 10,
    height: 10,
    transform: "rotate(0,130,20)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 25,
    width: 10,
    height: 10,
    transform: "rotate(0,130,30)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 65,
    width: 10,
    height: 10,
    transform: "rotate(0,130,70)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 85,
    width: 10,
    height: 10,
    transform: "rotate(0,130,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 105,
    width: 10,
    height: 10,
    transform: "rotate(0,130,110)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 145,
    width: 10,
    height: 10,
    transform: "rotate(0,130,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 155,
    width: 10,
    height: 10,
    transform: "rotate(0,130,160)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 175,
    width: 10,
    height: 10,
    transform: "rotate(0,130,180)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 205,
    width: 10,
    height: 10,
    transform: "rotate(0,130,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 225,
    width: 10,
    height: 10,
    transform: "rotate(0,130,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 235,
    width: 10,
    height: 10,
    transform: "rotate(0,130,240)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 255,
    width: 10,
    height: 10,
    transform: "rotate(0,130,260)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 265,
    width: 10,
    height: 10,
    transform: "rotate(0,130,270)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 5,
    width: 10,
    height: 10,
    transform: "rotate(0,140,10)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 15,
    width: 10,
    height: 10,
    transform: "rotate(0,140,20)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 25,
    width: 10,
    height: 10,
    transform: "rotate(0,140,30)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 35,
    width: 10,
    height: 10,
    transform: "rotate(0,140,40)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 75,
    width: 10,
    height: 10,
    transform: "rotate(0,140,80)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 115,
    width: 10,
    height: 10,
    transform: "rotate(0,140,120)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 125,
    width: 10,
    height: 10,
    transform: "rotate(0,140,130)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 135,
    width: 10,
    height: 10,
    transform: "rotate(0,140,140)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 145,
    width: 10,
    height: 10,
    transform: "rotate(0,140,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 155,
    width: 10,
    height: 10,
    transform: "rotate(0,140,160)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 165,
    width: 10,
    height: 10,
    transform: "rotate(0,140,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 185,
    width: 10,
    height: 10,
    transform: "rotate(0,140,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 205,
    width: 10,
    height: 10,
    transform: "rotate(0,140,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 215,
    width: 10,
    height: 10,
    transform: "rotate(0,140,220)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 225,
    width: 10,
    height: 10,
    transform: "rotate(0,140,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 235,
    width: 10,
    height: 10,
    transform: "rotate(0,140,240)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 275,
    width: 10,
    height: 10,
    transform: "rotate(0,140,280)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 285,
    width: 10,
    height: 10,
    transform: "rotate(0,140,290)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 35,
    width: 10,
    height: 10,
    transform: "rotate(0,150,40)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 65,
    width: 10,
    height: 10,
    transform: "rotate(0,150,70)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 75,
    width: 10,
    height: 10,
    transform: "rotate(0,150,80)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 105,
    width: 10,
    height: 10,
    transform: "rotate(0,150,110)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 115,
    width: 10,
    height: 10,
    transform: "rotate(0,150,120)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 125,
    width: 10,
    height: 10,
    transform: "rotate(0,150,130)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 145,
    width: 10,
    height: 10,
    transform: "rotate(0,150,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 165,
    width: 10,
    height: 10,
    transform: "rotate(0,150,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 175,
    width: 10,
    height: 10,
    transform: "rotate(0,150,180)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 225,
    width: 10,
    height: 10,
    transform: "rotate(0,150,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 235,
    width: 10,
    height: 10,
    transform: "rotate(0,150,240)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 265,
    width: 10,
    height: 10,
    transform: "rotate(0,150,270)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 285,
    width: 10,
    height: 10,
    transform: "rotate(0,150,290)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 5,
    width: 10,
    height: 10,
    transform: "rotate(0,160,10)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 55,
    width: 10,
    height: 10,
    transform: "rotate(0,160,60)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 85,
    width: 10,
    height: 10,
    transform: "rotate(0,160,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 95,
    width: 10,
    height: 10,
    transform: "rotate(0,160,100)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 105,
    width: 10,
    height: 10,
    transform: "rotate(0,160,110)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 115,
    width: 10,
    height: 10,
    transform: "rotate(0,160,120)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 135,
    width: 10,
    height: 10,
    transform: "rotate(0,160,140)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 195,
    width: 10,
    height: 10,
    transform: "rotate(0,160,200)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 205,
    width: 10,
    height: 10,
    transform: "rotate(0,160,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 215,
    width: 10,
    height: 10,
    transform: "rotate(0,160,220)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 225,
    width: 10,
    height: 10,
    transform: "rotate(0,160,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 235,
    width: 10,
    height: 10,
    transform: "rotate(0,160,240)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165,
    y: 25,
    width: 10,
    height: 10,
    transform: "rotate(0,170,30)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165,
    y: 45,
    width: 10,
    height: 10,
    transform: "rotate(0,170,50)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165,
    y: 65,
    width: 10,
    height: 10,
    transform: "rotate(0,170,70)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165,
    y: 75,
    width: 10,
    height: 10,
    transform: "rotate(0,170,80)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165,
    y: 105,
    width: 10,
    height: 10,
    transform: "rotate(0,170,110)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165,
    y: 115,
    width: 10,
    height: 10,
    transform: "rotate(0,170,120)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165,
    y: 125,
    width: 10,
    height: 10,
    transform: "rotate(0,170,130)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165,
    y: 135,
    width: 10,
    height: 10,
    transform: "rotate(0,170,140)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165,
    y: 155,
    width: 10,
    height: 10,
    transform: "rotate(0,170,160)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165,
    y: 195,
    width: 10,
    height: 10,
    transform: "rotate(0,170,200)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165,
    y: 205,
    width: 10,
    height: 10,
    transform: "rotate(0,170,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165,
    y: 215,
    width: 10,
    height: 10,
    transform: "rotate(0,170,220)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165,
    y: 225,
    width: 10,
    height: 10,
    transform: "rotate(0,170,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165,
    y: 245,
    width: 10,
    height: 10,
    transform: "rotate(0,170,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165,
    y: 255,
    width: 10,
    height: 10,
    transform: "rotate(0,170,260)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165,
    y: 275,
    width: 10,
    height: 10,
    transform: "rotate(0,170,280)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 35,
    width: 10,
    height: 10,
    transform: "rotate(0,180,40)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 45,
    width: 10,
    height: 10,
    transform: "rotate(0,180,50)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 95,
    width: 10,
    height: 10,
    transform: "rotate(0,180,100)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 105,
    width: 10,
    height: 10,
    transform: "rotate(0,180,110)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 115,
    width: 10,
    height: 10,
    transform: "rotate(0,180,120)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 135,
    width: 10,
    height: 10,
    transform: "rotate(0,180,140)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 155,
    width: 10,
    height: 10,
    transform: "rotate(0,180,160)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 175,
    width: 10,
    height: 10,
    transform: "rotate(0,180,180)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 205,
    width: 10,
    height: 10,
    transform: "rotate(0,180,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 215,
    width: 10,
    height: 10,
    transform: "rotate(0,180,220)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 225,
    width: 10,
    height: 10,
    transform: "rotate(0,180,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 255,
    width: 10,
    height: 10,
    transform: "rotate(0,180,260)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 275,
    width: 10,
    height: 10,
    transform: "rotate(0,180,280)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 285,
    width: 10,
    height: 10,
    transform: "rotate(0,180,290)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185,
    y: 5,
    width: 10,
    height: 10,
    transform: "rotate(0,190,10)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185,
    y: 25,
    width: 10,
    height: 10,
    transform: "rotate(0,190,30)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185,
    y: 35,
    width: 10,
    height: 10,
    transform: "rotate(0,190,40)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185,
    y: 45,
    width: 10,
    height: 10,
    transform: "rotate(0,190,50)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185,
    y: 65,
    width: 10,
    height: 10,
    transform: "rotate(0,190,70)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185,
    y: 75,
    width: 10,
    height: 10,
    transform: "rotate(0,190,80)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185,
    y: 85,
    width: 10,
    height: 10,
    transform: "rotate(0,190,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185,
    y: 95,
    width: 10,
    height: 10,
    transform: "rotate(0,190,100)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185,
    y: 135,
    width: 10,
    height: 10,
    transform: "rotate(0,190,140)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185,
    y: 145,
    width: 10,
    height: 10,
    transform: "rotate(0,190,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185,
    y: 175,
    width: 10,
    height: 10,
    transform: "rotate(0,190,180)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185,
    y: 185,
    width: 10,
    height: 10,
    transform: "rotate(0,190,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185,
    y: 205,
    width: 10,
    height: 10,
    transform: "rotate(0,190,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185,
    y: 215,
    width: 10,
    height: 10,
    transform: "rotate(0,190,220)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185,
    y: 245,
    width: 10,
    height: 10,
    transform: "rotate(0,190,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185,
    y: 265,
    width: 10,
    height: 10,
    transform: "rotate(0,190,270)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185,
    y: 275,
    width: 10,
    height: 10,
    transform: "rotate(0,190,280)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185,
    y: 285,
    width: 10,
    height: 10,
    transform: "rotate(0,190,290)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 15,
    width: 10,
    height: 10,
    transform: "rotate(0,200,20)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 85,
    width: 10,
    height: 10,
    transform: "rotate(0,200,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 105,
    width: 10,
    height: 10,
    transform: "rotate(0,200,110)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 125,
    width: 10,
    height: 10,
    transform: "rotate(0,200,130)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 155,
    width: 10,
    height: 10,
    transform: "rotate(0,200,160)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 175,
    width: 10,
    height: 10,
    transform: "rotate(0,200,180)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 205,
    width: 10,
    height: 10,
    transform: "rotate(0,200,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 225,
    width: 10,
    height: 10,
    transform: "rotate(0,200,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 235,
    width: 10,
    height: 10,
    transform: "rotate(0,200,240)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 275,
    width: 10,
    height: 10,
    transform: "rotate(0,200,280)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 285,
    width: 10,
    height: 10,
    transform: "rotate(0,200,290)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 5,
    width: 10,
    height: 10,
    transform: "rotate(0,210,10)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 25,
    width: 10,
    height: 10,
    transform: "rotate(0,210,30)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 55,
    width: 10,
    height: 10,
    transform: "rotate(0,210,60)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 65,
    width: 10,
    height: 10,
    transform: "rotate(0,210,70)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 125,
    width: 10,
    height: 10,
    transform: "rotate(0,210,130)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 165,
    width: 10,
    height: 10,
    transform: "rotate(0,210,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 175,
    width: 10,
    height: 10,
    transform: "rotate(0,210,180)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 185,
    width: 10,
    height: 10,
    transform: "rotate(0,210,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 205,
    width: 10,
    height: 10,
    transform: "rotate(0,210,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 215,
    width: 10,
    height: 10,
    transform: "rotate(0,210,220)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 225,
    width: 10,
    height: 10,
    transform: "rotate(0,210,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 235,
    width: 10,
    height: 10,
    transform: "rotate(0,210,240)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 245,
    width: 10,
    height: 10,
    transform: "rotate(0,210,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 265,
    width: 10,
    height: 10,
    transform: "rotate(0,210,270)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215,
    y: 85,
    width: 10,
    height: 10,
    transform: "rotate(0,220,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215,
    y: 95,
    width: 10,
    height: 10,
    transform: "rotate(0,220,100)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215,
    y: 105,
    width: 10,
    height: 10,
    transform: "rotate(0,220,110)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215,
    y: 115,
    width: 10,
    height: 10,
    transform: "rotate(0,220,120)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215,
    y: 165,
    width: 10,
    height: 10,
    transform: "rotate(0,220,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215,
    y: 175,
    width: 10,
    height: 10,
    transform: "rotate(0,220,180)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215,
    y: 195,
    width: 10,
    height: 10,
    transform: "rotate(0,220,200)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215,
    y: 205,
    width: 10,
    height: 10,
    transform: "rotate(0,220,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215,
    y: 245,
    width: 10,
    height: 10,
    transform: "rotate(0,220,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215,
    y: 275,
    width: 10,
    height: 10,
    transform: "rotate(0,220,280)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215,
    y: 285,
    width: 10,
    height: 10,
    transform: "rotate(0,220,290)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225,
    y: 85,
    width: 10,
    height: 10,
    transform: "rotate(0,230,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225,
    y: 185,
    width: 10,
    height: 10,
    transform: "rotate(0,230,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225,
    y: 195,
    width: 10,
    height: 10,
    transform: "rotate(0,230,200)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225,
    y: 205,
    width: 10,
    height: 10,
    transform: "rotate(0,230,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225,
    y: 225,
    width: 10,
    height: 10,
    transform: "rotate(0,230,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225,
    y: 245,
    width: 10,
    height: 10,
    transform: "rotate(0,230,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225,
    y: 265,
    width: 10,
    height: 10,
    transform: "rotate(0,230,270)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225,
    y: 275,
    width: 10,
    height: 10,
    transform: "rotate(0,230,280)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225,
    y: 285,
    width: 10,
    height: 10,
    transform: "rotate(0,230,290)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 105,
    width: 10,
    height: 10,
    transform: "rotate(0,240,110)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 115,
    width: 10,
    height: 10,
    transform: "rotate(0,240,120)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 125,
    width: 10,
    height: 10,
    transform: "rotate(0,240,130)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 145,
    width: 10,
    height: 10,
    transform: "rotate(0,240,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 175,
    width: 10,
    height: 10,
    transform: "rotate(0,240,180)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 185,
    width: 10,
    height: 10,
    transform: "rotate(0,240,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 205,
    width: 10,
    height: 10,
    transform: "rotate(0,240,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 245,
    width: 10,
    height: 10,
    transform: "rotate(0,240,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 285,
    width: 10,
    height: 10,
    transform: "rotate(0,240,290)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245,
    y: 85,
    width: 10,
    height: 10,
    transform: "rotate(0,250,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245,
    y: 115,
    width: 10,
    height: 10,
    transform: "rotate(0,250,120)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245,
    y: 125,
    width: 10,
    height: 10,
    transform: "rotate(0,250,130)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245,
    y: 135,
    width: 10,
    height: 10,
    transform: "rotate(0,250,140)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245,
    y: 165,
    width: 10,
    height: 10,
    transform: "rotate(0,250,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245,
    y: 185,
    width: 10,
    height: 10,
    transform: "rotate(0,250,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245,
    y: 205,
    width: 10,
    height: 10,
    transform: "rotate(0,250,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245,
    y: 215,
    width: 10,
    height: 10,
    transform: "rotate(0,250,220)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245,
    y: 225,
    width: 10,
    height: 10,
    transform: "rotate(0,250,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245,
    y: 235,
    width: 10,
    height: 10,
    transform: "rotate(0,250,240)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245,
    y: 245,
    width: 10,
    height: 10,
    transform: "rotate(0,250,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245,
    y: 255,
    width: 10,
    height: 10,
    transform: "rotate(0,250,260)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245,
    y: 275,
    width: 10,
    height: 10,
    transform: "rotate(0,250,280)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255,
    y: 95,
    width: 10,
    height: 10,
    transform: "rotate(0,260,100)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255,
    y: 105,
    width: 10,
    height: 10,
    transform: "rotate(0,260,110)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255,
    y: 115,
    width: 10,
    height: 10,
    transform: "rotate(0,260,120)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255,
    y: 125,
    width: 10,
    height: 10,
    transform: "rotate(0,260,130)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255,
    y: 135,
    width: 10,
    height: 10,
    transform: "rotate(0,260,140)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255,
    y: 155,
    width: 10,
    height: 10,
    transform: "rotate(0,260,160)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255,
    y: 165,
    width: 10,
    height: 10,
    transform: "rotate(0,260,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255,
    y: 185,
    width: 10,
    height: 10,
    transform: "rotate(0,260,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255,
    y: 205,
    width: 10,
    height: 10,
    transform: "rotate(0,260,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255,
    y: 215,
    width: 10,
    height: 10,
    transform: "rotate(0,260,220)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255,
    y: 245,
    width: 10,
    height: 10,
    transform: "rotate(0,260,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255,
    y: 265,
    width: 10,
    height: 10,
    transform: "rotate(0,260,270)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265,
    y: 85,
    width: 10,
    height: 10,
    transform: "rotate(0,270,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265,
    y: 95,
    width: 10,
    height: 10,
    transform: "rotate(0,270,100)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265,
    y: 105,
    width: 10,
    height: 10,
    transform: "rotate(0,270,110)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265,
    y: 115,
    width: 10,
    height: 10,
    transform: "rotate(0,270,120)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265,
    y: 135,
    width: 10,
    height: 10,
    transform: "rotate(0,270,140)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265,
    y: 155,
    width: 10,
    height: 10,
    transform: "rotate(0,270,160)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265,
    y: 165,
    width: 10,
    height: 10,
    transform: "rotate(0,270,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265,
    y: 175,
    width: 10,
    height: 10,
    transform: "rotate(0,270,180)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265,
    y: 195,
    width: 10,
    height: 10,
    transform: "rotate(0,270,200)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265,
    y: 235,
    width: 10,
    height: 10,
    transform: "rotate(0,270,240)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265,
    y: 245,
    width: 10,
    height: 10,
    transform: "rotate(0,270,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265,
    y: 265,
    width: 10,
    height: 10,
    transform: "rotate(0,270,270)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265,
    y: 285,
    width: 10,
    height: 10,
    transform: "rotate(0,270,290)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275,
    y: 85,
    width: 10,
    height: 10,
    transform: "rotate(0,280,90)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275,
    y: 95,
    width: 10,
    height: 10,
    transform: "rotate(0,280,100)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275,
    y: 105,
    width: 10,
    height: 10,
    transform: "rotate(0,280,110)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275,
    y: 115,
    width: 10,
    height: 10,
    transform: "rotate(0,280,120)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275,
    y: 135,
    width: 10,
    height: 10,
    transform: "rotate(0,280,140)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275,
    y: 145,
    width: 10,
    height: 10,
    transform: "rotate(0,280,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275,
    y: 165,
    width: 10,
    height: 10,
    transform: "rotate(0,280,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275,
    y: 175,
    width: 10,
    height: 10,
    transform: "rotate(0,280,180)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275,
    y: 205,
    width: 10,
    height: 10,
    transform: "rotate(0,280,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275,
    y: 215,
    width: 10,
    height: 10,
    transform: "rotate(0,280,220)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275,
    y: 225,
    width: 10,
    height: 10,
    transform: "rotate(0,280,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275,
    y: 235,
    width: 10,
    height: 10,
    transform: "rotate(0,280,240)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275,
    y: 275,
    width: 10,
    height: 10,
    transform: "rotate(0,280,280)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285,
    y: 95,
    width: 10,
    height: 10,
    transform: "rotate(0,290,100)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285,
    y: 115,
    width: 10,
    height: 10,
    transform: "rotate(0,290,120)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285,
    y: 155,
    width: 10,
    height: 10,
    transform: "rotate(0,290,160)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285,
    y: 165,
    width: 10,
    height: 10,
    transform: "rotate(0,290,170)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285,
    y: 175,
    width: 10,
    height: 10,
    transform: "rotate(0,290,180)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285,
    y: 195,
    width: 10,
    height: 10,
    transform: "rotate(0,290,200)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285,
    y: 205,
    width: 10,
    height: 10,
    transform: "rotate(0,290,210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285,
    y: 225,
    width: 10,
    height: 10,
    transform: "rotate(0,290,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285,
    y: 245,
    width: 10,
    height: 10,
    transform: "rotate(0,290,250)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285,
    y: 255,
    width: 10,
    height: 10,
    transform: "rotate(0,290,260)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285,
    y: 265,
    width: 10,
    height: 10,
    transform: "rotate(0,290,270)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285,
    y: 275,
    width: 10,
    height: 10,
    transform: "rotate(0,290,280)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285,
    y: 285,
    width: 10,
    height: 10,
    transform: "rotate(0,290,290)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "corners-square-color-0-0"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M 5 40a 35 35, 0, 0, 0, 35 35h 30a 5 5, 0, 0, 0, 5 -5v -30a 35 35, 0, 0, 0, -35 -35a 35 35, 0, 0, 0, -35 35zM 40 15a 25 25, 0, 0, 1, 25 25v 25h -25a 25 25, 0, 0, 1, -25 -25a 25 25, 0, 0, 1, 25 -25z",
    transform: "rotate(0,40,40)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "corners-dot-color-0-0"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M 25 35.714285714285715v 8.571428571428571a 10.714285714285714 10.714285714285714, 0, 0, 0, 10.714285714285714 10.714285714285714h 19.285714285714285v -19.285714285714285a 10.714285714285714 10.714285714285714, 0, 0, 0, -10.714285714285714 -10.714285714285714h -8.571428571428571a 10.714285714285714 10.714285714285714, 0, 0, 0, -10.714285714285714 10.714285714285714",
    transform: "rotate(0,40,40)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "corners-square-color-1-0"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M 225 40a 35 35, 0, 0, 0, 35 35h 30a 5 5, 0, 0, 0, 5 -5v -30a 35 35, 0, 0, 0, -35 -35a 35 35, 0, 0, 0, -35 35zM 260 15a 25 25, 0, 0, 1, 25 25v 25h -25a 25 25, 0, 0, 1, -25 -25a 25 25, 0, 0, 1, 25 -25z",
    transform: "rotate(90,260,40)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "corners-dot-color-1-0"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M 245 35.714285714285715v 8.571428571428571a 10.714285714285714 10.714285714285714, 0, 0, 0, 10.714285714285714 10.714285714285714h 19.285714285714285v -19.285714285714285a 10.714285714285714 10.714285714285714, 0, 0, 0, -10.714285714285714 -10.714285714285714h -8.571428571428571a 10.714285714285714 10.714285714285714, 0, 0, 0, -10.714285714285714 10.714285714285714",
    transform: "rotate(90,260,40)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "corners-square-color-0-1"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M 5 260a 35 35, 0, 0, 0, 35 35h 30a 5 5, 0, 0, 0, 5 -5v -30a 35 35, 0, 0, 0, -35 -35a 35 35, 0, 0, 0, -35 35zM 40 235a 25 25, 0, 0, 1, 25 25v 25h -25a 25 25, 0, 0, 1, -25 -25a 25 25, 0, 0, 1, 25 -25z",
    transform: "rotate(-90,40,260)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "corners-dot-color-0-1"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M 25 255.71428571428572v 8.571428571428571a 10.714285714285714 10.714285714285714, 0, 0, 0, 10.714285714285714 10.714285714285714h 19.285714285714285v -19.285714285714285a 10.714285714285714 10.714285714285714, 0, 0, 0, -10.714285714285714 -10.714285714285714h -8.571428571428571a 10.714285714285714 10.714285714285714, 0, 0, 0, -10.714285714285714 10.714285714285714",
    transform: "rotate(-90,40,260)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMommiesIg);
export default __webpack_public_path__ + "static/media/mommiesIG.3d2ea4f7bde06ad570c76d77169f50cf.svg";
export { ForwardRef as ReactComponent };